@if (formCategories) {
    <div class="form-status-overview">
        <div class="detail-page-action-bar">
            <input
                type="text"
                class="form-control form-control-sm"
                name="filterInput"
                [(ngModel)]="filter"
                (debounce-input-event)="filterTrigger()"
                placeholder="{{ 'formStatus.filterPlaceholder' | t }}"
                inputTooltip
            />
        </div>

        <div class="categories">
            @for (category of formCategories; track category) {
                @if (!category.hidden) {
                    <div class="category-overview">
                        <div class="category-title">
                            {{ category.category }}
                        </div>
                        @for (form of category.forms; track form; let i = $index) {
                            <div
                                class="status-overview"
                                [class.workflow-status-overview]="form.Workflow"
                                data-uiid="form-status-card"
                            >
                                <div
                                    [hidden]="filter && form._genericConfig._visibleRowCount === 0"
                                >
                                    <div class="detail-page-card headers mb-0 row">
                                        <div
                                            class="detail-page-card-title col-{{
                                                form.CanInvite ? '12' : '6'
                                            }}"
                                        >
                                            <div
                                                class="open-color me-2"
                                                data-uiid="form-status-open-state"
                                                [style.background-color]="
                                                    form.IsOpenForEntries
                                                        ? form.FormOutOfDateRange
                                                            ? 'orange'
                                                            : 'green'
                                                        : 'red'
                                                "
                                                [matTooltip]="
                                                    'formStatus.openStateTooltip'
                                                        | t
                                                            : {
                                                                  state: form.IsOpenForEntries
                                                                      ? form.FormOutOfDateRange
                                                                          ? 'halted'
                                                                          : 'open'
                                                                      : 'closed',
                                                              }
                                                "
                                            ></div>
                                            {{ form.Title }}
                                            @if (form.Workflow) {
                                                <i
                                                    class="fas fa-code-branch ms-2"
                                                    [matTooltip]="'formStatus.workflowFormTooltip' | t"
                                                ></i>
                                            }
                                            @if (form.EndDate) {
                                                <small class="text-muted ms-2">{{
                                                    'formStatus.endDate'
                                                        | t: { date: form.EndDate | dateFormat }
                                                }}</small>
                                            }
                                        </div>
                                        <div
                                            class="detail-page-card-actions col-{{
                                                form.CanInvite ? '12' : '6'
                                            }}"
                                        >
                                            @if (form.CanInvite) {
                                                <div class="left-items">
                                                    <button
                                                        class="btn btn-raised green"
                                                        data-uiid="form-status-invite-button"
                                                        (click)="openRequiredInvite(form)"
                                                    >
                                                        <i class="far fa-envelope"></i>
                                                        <span>{{ 'formStatus.inviteUsersBtn' | t }}</span>
                                                    </button>
                                                    @if (form._hasOpenInvites) {
                                                        <button
                                                            class="btn btn-raised dark"
                                                            data-uiid="form-status-remind-button"
                                                            (click)="openRemindInvite(form)"
                                                        >
                                                            <i class="far fa-bell"></i>
                                                            <span>{{ 'formStatus.remindInviteesBtn' | t }}</span>
                                                        </button>
                                                    }
                                                </div>
                                            }
                                            <div class="right-items">
                                                <button
                                                    class="btn btn-raised"
                                                    (click)="openOverview(form)"
                                                >
                                                    <span>{{ 'formStatus.allResultsBtn' | t }}</span>
                                                    <i class="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <generic-list-manager
                                        [config]="form._genericConfig"
                                    ></generic-list-manager>
                                </div>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
